import React, {useEffect, useState} from 'react';
import {DataGrid, GridOverlay} from '@mui/x-data-grid';
import {getRFIDMappingList} from '../../services/asset.service'
import * as CryptoJS from "crypto-js";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import {FormControl, InputLabel, MenuItem, Pagination, Select} from "@mui/material";

function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return year + '-' + month + '-' + day;
        //return `${dte.getFullYear()}-${dte.getMonth()+1}-${dte.getDate()}`;
    } else {
        return null;
    }
}
const columns = [
    {"field": "tag", "editable": false, "hide": false, "headerName": "TAG", "width": 250},
    {"field": "epc_no", "editable": false, "hide": false, "headerName": "EPC No", "width": 250},
    {
        "field": "updated_at", "editable": false, "hide": false, "headerName": "Date of Linking/De-linking", "width": 230,
        renderCell: (params) => (
            <p>{getFormatedDate(params.row.updated_at)}</p>
        )
    }
];
const CustomLoader = () => (
    <GridOverlay>
        <CircularProgress color="primary" size={30}/>
    </GridOverlay>
);
function ListRFIDMapping() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const calculateOffset = (page, pageSize) => (page - 1) * pageSize;
    useEffect(() => {
        const offset = calculateOffset(page, pageSize);
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {
                'offset': offset,
                'pageSize': pageSize,
            },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = {'token': EncryptData};

        // Show loader when the request starts
        setLoading(true);

        // Fetch division list
        getRFIDMappingList(oData)
            .then((res) => {
                if (res?.data?.data?.length) {
                    setItems(res.data.data);
                    setTotalItems(res.data.total || 0);
                } else {
                    setItems('');
                }
            })
            .catch((error) => {
                console.error('Error fetching rfid list:', error);
            })
            .finally(() => {
                // Hide loader when the request completes (either success or failure)
                setLoading(false);
            });
    }, [page, pageSize]);  // Empty dependency array means this effect runs once on mount

    const handlePageSizeChange = (value) => {
        setPageSize(value);
        setPage(1);
    };
    const handlePageChange = (event, value) => {
        setPage(value);
    };
    const totalPages = Math.ceil(totalItems / pageSize);

    return (
        <div className='container'>
            <div className='row mb-4'>
                <div className='col-md-6'><h5>View RFID TAG Mapping List</h5></div>

            </div>

            {loading ? (
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <DataGrid
                    rows={items}
                    getRowId={(row) => row.id}
                    columns={columns}
                    autoHeight
                    components={{
                        LoadingOverlay: CustomLoader,
                        Pagination: () => (
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                mt: 2
                            }}>
                                <Box sx={{mr: 4}}>
                                    Showing {items.length} records out of {totalItems}
                                </Box>
                                <FormControl variant="outlined" sx={{minWidth: 120}}>
                                    <InputLabel>Rows per page</InputLabel>
                                    <Select
                                        value={pageSize}
                                        onChange={(event) => handlePageSizeChange(Number(event.target.value))}
                                        label="Rows per page"
                                    >
                                        {[10, 25, 50, 100, 200, 500].map((size) => (
                                            <MenuItem key={size} value={size}>
                                                {size}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>


                                <Pagination
                                    count={totalPages}
                                    page={page}
                                    onChange={handlePageChange}
                                    variant="outlined"
                                    shape="rounded"
                                />

                            </Box>
                        ),
                    }}
                    loading={loading}
                />
            )}

        </div>
    )
}

export default ListRFIDMapping
